import { routeToAnalyticsName } from 'common/composition/useAnalytics.js'
import { useUserAuthStore } from 'src/stores/user/auth'
import { isAbtestEnabled } from 'src/common/config'
import {
  initFirebase,
  logAnalyticsEvent,
  setAnalyticsUserId,
  setAnalyticsUserProperties,
} from 'src/services/firebase/index.js'
import { getConfig } from '@/configs/index.js'

export default ({ router }) => {
  try {
    const firebaseConfig = getConfig().firebase

    if (typeof window === 'undefined' || !firebaseConfig?.apiKey) {
      return
    }

    const isProduction = process.env.NODE_ENV === 'production' && process.env.ENVIRONMENT === 'production'

    if (!isProduction) {
      return
    }

    if (!isAbtestEnabled()) {
      return
    }

    initFirebase({ config: firebaseConfig })

    router.afterEach((to, from, failure) => {
      if (failure) {
        return
      }
      try {
        logAnalyticsEvent('page_view', {
          page_name: routeToAnalyticsName(router, to),
          page_location: window.location.href,
          page_title: document.title,
        })
      } catch {
        return
      }
    })

    try {
      const userAuthStore = useUserAuthStore()
      const user = userAuthStore.getUser

      if (user) {
        setAnalyticsUserId(user.id)
        setAnalyticsUserProperties({
          region: userAuthStore.getUserRegion ?? '',
          currency: userAuthStore.getUserCurrencyCode ?? '',
          language: userAuthStore.getUserLanguage ?? '',
          vip: user.vip ? 'true' : 'false',
        })
      }
    } catch {
      return
    }
  } catch {
    return
  }
}
